<template>
  <div class="manager">
    <ErrorAlert :error="error" :centered="true" />
    <div
      v-if="success"
      class="alert alert-success text-center"
      role="alert">
      {{ successMessage }}
    </div>
    <div class="card">
      <div class="card-header">
        <ul class="nav nav-tabs card-header-tabs" role="tablist">
          <li class="nav-item">
            <a
              class="nav-link"
              :class="{ active: activeTab === 'crm' }"
              href="#"
              @click.prevent="activeTab = 'crm'">CRM</a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              :class="{ active: activeTab === 'ramal' }"
              href="#"
              @click.prevent="activeTab = 'ramal'">Ramal</a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              :class="{ active: activeTab === 'webhook' }"
              href="#"
              @click.prevent="activeTab = 'webhook'">Webhook</a>
          </li>
        </ul>
      </div>
      <div class="card-body">
        <div class="tab-content">
        <div v-show="activeTab === 'crm'">
        <div class="dataTables_wrapper">
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <div class="collapse d-md-block">
                <div class="d-block d-md-inline-block">
                  <div class="btn-group float-md-left mr-1 mb-1">
                    <button
                      class="btn btn-outline-dark btn-xs dropdown-toggle"
                      type="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false">
                      Ordenar
                      <i class="ik ik-chevron-down mr-0 align-middle" />
                    </button>
                    <div class="dropdown-menu">
                      <a
                        class="dropdown-item"
                        :class="{
                          'bg-inverse': order === 'asc',
                          'text-white': order === 'asc'
                        }"
                        href="#"
                        @click.prevent="sortUserIntegrations('asc')">Crescente</a>
                      <a
                        class="dropdown-item"
                        :class="{
                          'bg-inverse': order === 'desc',
                          'text-white': order === 'desc'
                        }"
                        href="#"
                        @click.prevent="sortUserIntegrations('desc')">Decrescente</a>
                    </div>
                  </div>
                  <div class="search-sm d-inline-block float-md-left mr-1 mb-1 align-top">
                    <div class="input-group input-group-button">
                      <div class="input-group-prepend">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Pesquisar..."
                          v-model="search"
                          @keyup="searchUserIntegrations">
                        <div class="input-group-append">
                          <button
                            class="btn btn-outline-dark"
                            type="button"
                            @click.prevent="clearSearchUserIntegrations">Limpar</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="user-integrations">
          <div class="integration-item activecampaign col-4">
            <integration-active-campaign @onError="onError" />
          </div>
          <div class="integration-item agendor col-4">
            <integration-agendor @onError="onError" />
          </div>
          <div class="integration-item appfacilita col-4">
            <integration-app-facilita @onError="onError" />
          </div>
          <div
            class="integration-item clickup col-4">
            <integration-clickup @onError="onError" />
          </div>
          <div class="integration-item exactsales col-4">
            <integration-exact-sales @onError="onError" />
          </div>
          <div class="integration-item groner col-4">
            <integration-groner @onError="onError" />
          </div>
          <div
            class="integration-item gohighlevel col-4"
            v-if="isRolloutGoHighLevel">
            <integration-go-high-level @onError="onError" />
          </div>
          <div class="integration-item hubspot col-4">
            <integration-hubspot @onError="onError" />
          </div>
          <div class="integration-item kommo featured col-4">
            <integration-kommo @onError="onError" />
          </div>
          <div class="integration-item moskit col-4">
            <integration-moskit @onError="onError" />
          </div>
          <div class="integration-item nectar col-4">
            <integration-nectar @onError="onError" />
          </div>
          <div class="integration-item pipedrive col-4">
            <integration-pipedrive @onError="onError" />
          </div>
          <div class="integration-item pipefy col-4">
            <integration-pipefy @onError="onError" />
          </div>
          <div class="integration-item piperun col-4">
            <integration-piperun @onError="onError" />
          </div>
          <div class="integration-item ploomes col-4">
            <integration-ploomes @onError="onError" />
          </div>
          <div class="integration-item sunhub col-4">
            <integration-sunhub @onError="onError" />
          </div>
          <div class="integration-item rdstation col-4">
            <integration-rdstation-crm @onError="onError" />
          </div>
          <div class="integration-item salesflow col-4">
            <integration-salesflow-crm @onError="onError" />
          </div>
          <div class="integration-item salesforce col-4">
            <integration-salesforce @onError="onError" />
          </div>
          <div class="integration-item sharpspring col-4">
            <integration-sharpspring @onError="onError" />
          </div>
          <div class="integration-item vendfly col-4"
            v-if="isRolloutVendfly">
            <integration-vendfly
              @onError="onError" />
          </div>
          <div class="integration-item zendesk col-4">
            <integration-zendesk @onError="onError" />
          </div>
          <div class="integration-item zoho col-4">
            <integration-zoho @onError="onError" />
          </div>
          <div class="integration-item suggestions col-4">
            <div class="widget">
              <div class="widget-body">
                <a
                  title="Sugerir integrações"
                  class="link"
                  href="https://forms.gle/81oDtrCU4gjAvTWA9"
                  target="_blank">
                  <h1>Sugira novas integrações</h1>
                </a>
              </div>
            </div>
          </div>
        </div>
        </div>
        <div
          v-show="activeTab === 'ramal'"
          class="row">
          <div class="col-12 col-lg-8">
            <integration-sippulse @onError="onError" />
          </div>
        </div>
        <div
          v-show="activeTab === 'webhook'"
          class="row">
          <div class="col-12 col-lg-8">
            <integration-webhook @onError="onError" />
          </div>
          <div
            v-if="isAdmin && isRolloutCopyRecordings"
            class="col-12 col-lg-4">
            <copy-recordings @onError="onError" />
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loopback from '@/services/loopback'
import IntegrationActiveCampaign from './ActiveCampaign'
import IntegrationAgendor from './Agendor'
import IntegrationAppFacilita from './AppFacilita'
import IntegrationExactSales from './ExactSales'
import IntegrationGroner from './Groner'
import IntegrationHubspot from './HubSpot'
import IntegrationKommo from './Kommo'
import IntegrationMoskit from './Moskit'
import IntegrationNectar from './Nectar'
import IntegrationPipedrive from './Pipedrive'
import IntegrationPipefy from './Pipefy'
import IntegrationPiperun from './Piperun'
import IntegrationPloomes from './Ploomes'
import IntegrationSunhub from './Sunhub'
import IntegrationRdstationCrm from './RdstationCrm'
import IntegrationSalesflowCrm from './SalesflowCrm'
import IntegrationSalesforce from './Salesforce'
import IntegrationSharpspring from './Sharpspring'
import IntegrationSippulse from './Sippulse'
import IntegrationVendfly from './Vendfly'
import IntegrationZendesk from './Zendesk'
import IntegrationWebhook from './Webhook'
import CopyRecordings from './CopyRecordings'
import IntegrationZoho from './ZohoCrm'
import IntegrationClickup from './Clickup'
import IntegrationGoHighLevel from './GoHighLevel'

const USER_INTEGRATIONS = {
  activecampaign: 'ActiveCampaign CRM',
  agendor: 'Agendor CRM',
  appfacilita: 'AppFacilita CRM',
  exactsales: 'Exact Sales CRM',
  groner: 'Groner',
  gohighlevel: 'GoHighLevel CRM',
  hubspot: 'Hubspot CRM',
  kommo: 'Kommo',
  moskit: 'Ollow / Moskit',
  nectar: 'Nectar CRM',
  pipedrive: 'Pipedrive CRM',
  pipefy: 'Pipefy CRM',
  piperun: 'Piperun CRM',
  ploomes: 'Ploomes CRM',
  sunhub: 'Sunhub CRM',
  rdstation: 'RDStation CRM',
  salesflow: 'SalesFlow CRM',
  salesforce: 'Salesforce CRM',
  sharpspring: 'SharpSpring CRM',
  zendesk: 'Zendesk',
  zoho: 'Zoho CRM',
  clickup: 'Clickup',
  vendfly: 'Vendfly CRM'
}

export default {
  name: 'IntegrationManager',
  components: {
    IntegrationActiveCampaign,
    IntegrationAgendor,
    IntegrationAppFacilita,
    IntegrationExactSales,
    IntegrationGroner,
    IntegrationGoHighLevel,
    IntegrationHubspot,
    IntegrationKommo,
    IntegrationMoskit,
    IntegrationNectar,
    IntegrationPipedrive,
    IntegrationPipefy,
    IntegrationPiperun,
    IntegrationPloomes,
    IntegrationSunhub,
    IntegrationRdstationCrm,
    IntegrationSalesflowCrm,
    IntegrationSalesforce,
    IntegrationSharpspring,
    IntegrationSippulse,
    IntegrationZendesk,
    IntegrationWebhook,
    CopyRecordings,
    IntegrationZoho,
    IntegrationClickup,
    IntegrationVendfly
  },
  data () {
    return {
      error: null,
      activeTab: 'crm',
      isRolloutCopyRecordings: false,
      isRolloutVendfly: false,
      isRolloutGoHighLevel: false,
      search: '',
      order: 'asc',
      integrationSuccess: this.$route.query.success,
      integrationError: this.$route.query.error
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadIntegrationError()
      this.loadRolloutRecordingsCloud()
      this.loadRolloutVendfly()
      this.loadRolloutGoHighLevel()
    })
  },
  methods: {
    onError (err) {
      this.error = err
    },
    loadRolloutRecordingsCloud () {
      loopback
        .get('/rollout?featureFlag=copy-recordings')
        .then(rollout => {
          this.isRolloutCopyRecordings = rollout === 'ALLOWED'
        })
    },
    loadRolloutVendfly () {
      loopback
        .get('/rollout?featureFlag=vendfly-integration')
        .then(rollout => {
          this.isRolloutVendfly = rollout === 'ALLOWED'
        })
    },
    loadRolloutGoHighLevel () {
      loopback
        .get('/rollout?featureFlag=gohighlevel-integration')
        .then(rollout => {
          this.isRolloutGoHighLevel = rollout === 'ALLOWED'
        })
    },
    sortUserIntegrations (order) {
      this.order = order
      Object.keys(USER_INTEGRATIONS).sort((a, b) => {
        if (order === 'asc') {
          return a.localeCompare(b)
        }
        return b.localeCompare(a)
      }).forEach((integration, index) => {
        const el = document.querySelector(`.${integration}`)
        if (el) {
          el.style.order = index
        }
        const suggestionEl = document.querySelector('.suggestions')
        if (suggestionEl) {
          suggestionEl.style.order = Object.keys(USER_INTEGRATIONS).length
        }
      })
      // Mantém o CRM em destaque sempre no topo, independente da ordenação
      const featuredEl = document.querySelector('.integration-item.featured')
      if (featuredEl) {
        featuredEl.style.order = -1
      }
    },
    searchUserIntegrations () {
      const userIntegrationsKeys = Object.keys(USER_INTEGRATIONS)
      Object.values(USER_INTEGRATIONS).forEach((integration, index) => {
        const el = document.querySelector(`.${userIntegrationsKeys[index]}`)
        if (el) {
          if (integration.match(new RegExp(this.search.toLowerCase(), 'i'))) {
            el.style.display = 'inline-block'
          } else {
            el.style.display = 'none'
          }
        }
      })
    },
    clearSearchUserIntegrations () {
      Object.keys(USER_INTEGRATIONS).forEach(integration => {
        const el = document.querySelector(`.${integration}`)
        if (el) {
          el.style.display = 'inline-block'
        }
      })
      this.search = ''
    },
    loadIntegrationError () {
      if (this.integrationError) {
        const errorMessage = `Não foi possível realizar a integração com ${USER_INTEGRATIONS[this.integrationError]}. Por favor, tente novamente.`
        this.error = {
          message: errorMessage
        }
      }
    }
  },
  computed: {
    isAdmin () {
      return this.$store.state.auth.user && this.$store.state.auth.user.role === 'ADMIN'
    },
    success () {
      return this.integrationSuccess && this.integrationSuccess.length > 0
    },
    successMessage () {
      return `Integração com ${USER_INTEGRATIONS[this.integrationSuccess]} realizada com sucesso.`
    }
  }
}
</script>

<style lang="scss" scoped>
.embed-responsive {
  max-width: 800px;
  max-height: 600px;
  margin: auto;
}
.widget .widget-body {
  height: 144px !important;
  text-align: center;
}
/deep/ .link {
  color: blue !important;
  cursor: pointer;
  font-weight: bold;
}
/deep/ .state > h4 > small {
  font-size: 60%;
}

.user-integrations {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.integration-item {
  display: inline-block;
  margin: 0;
}

// CRM em destaque: sempre no topo da listagem + borda azul de realce
.integration-item.featured {
  order: -1;

  /deep/ .widget {
    border: 2px solid #007bff;
    border-radius: 6px;
    box-shadow: 0 0 12px rgba(0, 123, 255, 0.35);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Integration/Manager.vue